import { render, staticRenderFns } from "./changeprofileReply.vue?vue&type=template&id=382cca0d&scoped=true&"
import script from "./changeprofileReply.vue?vue&type=script&lang=js&"
export * from "./changeprofileReply.vue?vue&type=script&lang=js&"
import style0 from "./changeprofileReply.vue?vue&type=style&index=0&id=382cca0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382cca0d",
  null
  
)

export default component.exports